import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Tools } from "@app/util/tools";

@Component({
    selector: 'app-pre-cancel-dialog',
    template: require('./dialogError.html')
})
export class DialogErrorDialog {

    constructor(
        @Inject(Tools) private tools: any,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(MatDialogRef<DialogErrorDialog>) public dialogRef: MatDialogRef<DialogErrorDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
